import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getBundleService = async (materialID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/bundles/${materialID}`);
  return res;
};

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const postBundleService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.post(`${apiURL}/metalstrading/api/bundles`, payload);
  return res;
};

export const putBundleService = async (payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.createdByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/bundles`, payload);
  return res;
};
